module.exports = __webpack_public_path__ + "img/xczp.0d371bed.png";